<template>
  <section class="block key-stat-block">
    <span class="key-stat-block__qualifier" v-if="qualifier === '$'">{{ qualifier }}</span>
    <h1 class="key-stat-block__number">{{ number }}</h1>
    <span class="key-stat-block__qualifier" v-if="qualifier !== '$'">{{ qualifier }}</span>
    <span class="key-stat-block__tagline">{{ tagline }}</span>
  </section>
</template>

<script lang="ts">
export default {
  props: ['number', 'qualifier', 'tagline'],
}
</script>
<style lang="sass">
.key-stat-block

.key-stat-block__number
  display: inline-block
  font-size: 3.5em!important
  font-weight: 800

.key-stat-block__qualifier
  color: var(--accent-color)
  font-size: 2em
  font-weight: 200

.key-stat-block__tagline
  font-size: 1.25em
  font-weight: bold
  margin-left: .25em

@media screen and (max-width: 1200px)
  .key-stat-block__number
    font-size: 3em!important
  .key-stat-block__qualifier
    font-size: 1.25em
  .key-stat-block__tagline
    font-size: .75em
</style>
